const ORDINAL_SUFFIXES = {
  1: "st",
  2: "nd",
  3: "rd",
};

const DOLLAR_UNIT_RANGES = [
  { min: 1000, max: 999999, divisor: 1000, unit: "K" },
  { min: 1000000, max: 999999999, divisor: 1000000, unit: "M" },
  { min: 1000000000, max: 999999999999, divisor: 1000000000, unit: "B" },
  {
    min: 1000000000000,
    max: 999999999999999,
    divisor: 1000000000000,
    unit: "T",
  },
  {
    min: 1000000000000000,
    max: Number.MAX_SAFE_INTEGER,
    divisor: 1000000000000000,
    unit: "P",
  },
];

export const formatCategoryName = (categoryName) => {
  if (!categoryName) {
    return categoryName;
  }

  if (typeof categoryName !== "string") {
    return categoryName;
  }

  return categoryName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function capitalizeFirstLetterOfEachWord(str) {
  if (str === undefined) {
    return Number.NaN;
  }

  if (!str || str.length === 0) {
    return str;
  }

  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

export function addSuffix(number) {
  const lastDigit = number % 10;
  const suffix =
    number === 11 || number === 12 || number === 13
      ? "th"
      : ORDINAL_SUFFIXES[lastDigit] || "th";

  return (
    <>
      {number}
      <sup>{suffix}</sup>
    </>
  );
}

export const fnCheckDollarUnits = (value) => {
  const defaultResult = { score: value, unit: "" };
  if (value === 0) {
    return defaultResult;
  }

  const absoluteValue = Math.abs(value);

  const matchedRange = DOLLAR_UNIT_RANGES.find(
    (range) => absoluteValue >= range.min && absoluteValue <= range.max,
  );

  if (!matchedRange) {
    return defaultResult;
  }

  return {
    score: value / matchedRange.divisor,
    unit: matchedRange.unit,
  };
};

export const fnCheckUnits = (value, setScore, setUnit) => {
  const { score: currentScore, unit: currentUnit } = fnCheckDollarUnits(value);

  let _value = Math.round(currentScore * 10) / 10;
  const _decimal = Math.round((_value % 1) * 10);

  if (_decimal === 0) {
    setScore(Math.trunc(_value));
  } else {
    setScore(_value);
  }
  if (currentUnit === "M") {
    setUnit("MM");
  } else {
    setUnit(currentUnit);
  }
};
